import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { authInterceptor } from './modules/core/auth/interceptors/auth.interceptor';
import { AuthBootstrapService } from './modules/core/auth/services/auth-bootstrap.service';
import { DEFAULT_TRANSLATION_LOCALE } from './modules/core/i18n/translation-locale.constants';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    provideTranslateService({
      lang: DEFAULT_TRANSLATION_LOCALE,
      fallbackLang: DEFAULT_TRANSLATION_LOCALE,
      loader: provideTranslateHttpLoader({
        prefix: 'assets/i18n/',
        suffix: '.json',
      }),
    }),
    provideAppInitializer(() => inject(AuthBootstrapService).initialize()),
  ],
};
